module.exports = __webpack_public_path__ + "img/doc-uploaded.f3b103d3.svg";